import { render, staticRenderFns } from "./UserWeightCard.vue?vue&type=template&id=daa4628a&scoped=true"
import script from "./UserWeightCard.vue?vue&type=script&lang=js"
export * from "./UserWeightCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa4628a",
  null
  
)

export default component.exports